// WxQrCode.js
// 从 App.js 抽取出的「微信扫码登录」二维码组件

import React from 'react';

function WxQrCode({ apiBase }) {
  const [qrStatus, setQrStatus] = React.useState('loading'); // loading | ready | error
  const containerRef = React.useRef(null);
  const scriptRef = React.useRef(null);

  React.useEffect(() => {
    let mounted = true;

    const loadQrCode = async () => {
      try {
        setQrStatus('loading');

        // 获取参数
        const res = await fetch(`${apiBase}/api/auth/wx-qrcode-params`);
        const { appid, redirectUri, state } = await res.json();

        // 加载微信JS-SDK
        await new Promise((resolve, reject) => {
          if (document.getElementById('wx-login-sdk')) {
            resolve();
            return;
          }
          const script = document.createElement('script');
          script.id = 'wx-login-sdk';
          script.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
          scriptRef.current = script;
        });

        if (!mounted) return;

        // 清空容器
        if (containerRef.current) {
          containerRef.current.innerHTML = '';
        }

        // 生成二维码
        // eslint-disable-next-line no-new
        new window.WxLogin({
          self_redirect: false,
          id: 'wx-qrcode-container',
          appid,
          scope: 'snsapi_login',
          redirect_uri: redirectUri,
          state,
          style: 'black',
          href: '',
        });

        if (mounted) setQrStatus('ready');
      } catch(e) {
        console.error('加载微信二维码失败:', e);
        if (mounted) setQrStatus('error');
      }
    };

    loadQrCode();

    return () => {
      mounted = false;
    };
  }, [apiBase]);

  return (
    <div style={{ textAlign: 'center', padding: '10px 0' }}>
      <p style={{ fontSize: '0.85em', color: '#999', marginBottom: '16px' }}>
        使用微信扫码安全登录
      </p>

      {qrStatus === 'loading' && (
        <div style={{
          width: '200px', height: '200px', margin: '0 auto',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: '#f5f5f5', borderRadius: '8px',
        }}>
          <span style={{ color: '#999', fontSize: '0.9em' }}>加载中...</span>
        </div>
      )}

      {qrStatus === 'error' && (
        <div style={{
          width: '200px', height: '200px', margin: '0 auto',
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', background: '#fff2f0', borderRadius: '8px',
          border: '1px solid #ffccc7',
        }}>
          <span style={{ fontSize: '1.5em', marginBottom: '8px' }}>⚠️</span>
          <span style={{ color: '#ff4d4f', fontSize: '0.85em' }}>加载失败</span>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '8px', padding: '4px 12px',
              background: '#ff4d4f', color: 'white',
              border: 'none', borderRadius: '4px', cursor: 'pointer',
              fontSize: '0.8em',
            }}
          >
            刷新重试
          </button>
        </div>
      )}

      <div
        id="wx-qrcode-container"
        ref={containerRef}
        style={{ display: qrStatus === 'ready' ? 'block' : 'none' }}
      />

      <p style={{ color: '#bbb', fontSize: '0.8em', margin: '12px 0 0' }}>
        打开微信 → 扫一扫
      </p>
    </div>
  );
}

export default WxQrCode;
